import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export const NAMESPACE = 'KanBo/version/'
export const SET = NAMESPACE + 'SET'

const initialState = {
  version: null
}

export function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case SET:
      return {
        ...state,
        version: action.payload.version
      }
    default: return state
  }
}

export function set ({ version, changed }) {
  return {
    type: SET,
    payload: {
      version,
      changed
    }
  }
}

export default persistReducer({ key: 'version', storage }, reducer)
